import React, { useEffect , useState } from 'react';

import {
  Card,
  CardHeader ,
  CardBody,
  CardTitle,
  CardText, 
  CardSubtitle,
  Button,
  Container,
  Row,
  Col,
  Input,
  Label,
  Form,
  FormGroup
  
} from 'reactstrap';

import { useForm } from "react-hook-form"
import { FormInput , RenderErrors , FormError } from '../../../components/MyForm'

import { email_verification_code_send_action } from '../actions'


const EmailAddress = ({ 
   email , 
   set_email , 
   sent_verification_code,
   set_sent_verification_code,
   prev_step , 
   next_step 

}) => {

  const {
    register,
    handleSubmit,
    formState: { errors }, 
  } = useForm({
      mode: 'onChange',
      defaultValues: {
          'email' : email
      }
  });


  const [ servererror, setServerError] = useState({})
  


  const handle_submit_with_send_verification_code = async (data) => {
      try {
            set_email(data.email)
            const response = await email_verification_code_send_action(data.email)
            set_sent_verification_code(true)
            setTimeout(next_step(),250)
        } catch (error) {
            console.log('error response during email verification code submit')
            console.log(error)
            if(error.response.data) {
                setServerError((old)=> ({...old, ...error.response.data}))
            }
        }

  }


  const handle_submit = async (data) => {
      try {
            set_email(data.email)
            next_step()
        } catch (error) {
            console.log('error response during email verification code submit')
            console.log(error)
            if(error.response.data) {
                setServerError((old)=> ({...old, ...error.response.data}))
            }
        }

  }


  useEffect(() => {
  },[]);


  return (

   <Container className="mt-3 d-flex justify-content-center align-items-center">
    
    <Card className='w-50'>
    <CardBody>

    <Form>


    <FormGroup>
       <FormInput
        register={register}
        name='email'
        id='email'
        label='Email'
        type='text'
        validation={{
            required: 'Email address is empty!',
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
            },
        }}
        OnChangeCustom ={(e)=> setServerError({})}
        invalid={errors.email}
        disabled={sent_verification_code}
       />

       { 
          errors.email &&
          <FormError message={errors.email.message}/>
       }


    </FormGroup>

      { servererror && <RenderErrors errors={servererror}/> }

      <div className="d-flex align-items-center justify-content-center">

        <Button 
           color='primary' 
           onClick={prev_step}
         >
          Go Back
        </Button>

        &nbsp;&nbsp;
        <Button 
           type="submit" 
           color='primary' 
           onClick={handleSubmit(handle_submit_with_send_verification_code)}
           disabled={sent_verification_code}
         >
         Send Verification Code
        </Button>


        &nbsp;&nbsp;
          <Button 
            color='primary' 
            type="submit" 
            onClick={handleSubmit(handle_submit)}
            disabled={!sent_verification_code}
          >
           Next
          </Button>
      </div>

    </Form>

       </CardBody>
      </Card>
     </Container>
  )
}

export default EmailAddress;
